function scrollToHashTarget(extraOffset = 10) {
  const hash = window.location.hash;
  if (hash && document.querySelector(hash)) {
    const header = document.querySelector("header");
    const headerHeight = header ? header.getBoundingClientRect().height : 0;

    const targetElement = document.querySelector(hash);
    const elementPosition = targetElement.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerHeight - extraOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // ページ内リンククリックに対応
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      if (targetId.length > 1 && document.querySelector(targetId)) {
        e.preventDefault();
        history.pushState(null, null, targetId); // ハッシュ更新
        scrollToHashTarget();
      }
    });
  });
});

// ページ完全読み込み後（画像・フォント等すべて読み込んだ後）に実行
window.addEventListener("load", function () {
  setTimeout(() => {
    scrollToHashTarget();
  }, 100); // 遅延して確実に高さを取得
});
// ページ内リンクのヘッダーアキ調整&スムーズスクロール